/**
 * Constant values used by the API that is not directly accssible via the schema.
 */

export const DEFAULT_STRING_DELIMITER = ';';
export const DEFAULT_ID_DELIMITER = '$';
export const ROWS_PER_PAGE = 25;

export enum CUSTOM_SCHEME_PATH {
  Dispatch = 'dispatch',
  ShipmentTable = 'shipmentTable',
  TableDialog = 'tableDialog',
  PayNow = 'payNow',
  ExpandRow = 'expandRow',
  Form = 'form',
  SwitchProfile = 'switchProfile',
  EditHistory = 'editHistory',
  Logout = 'logout',
  Set = 'set',
  Remove = 'remove',
  Notify = 'notify',
  Download = 'download',
  GQL = 'gql',
}

export enum CUSTOM_SCHEME_PREFIX {
  Dialog = 'dialog:',
  Method = 'method:',
  File = 'file:',
}

/** URL-like shape for method: URLs parsed manually (new URL() is unreliable for custom schemes). Reused by useHandleMethod and useHandleCustomSchemeAndQuery. */
export type MethodUrlLike = {
  pathname: string;
  searchParams: URLSearchParams;
  href: string;
};
